module.exports = __webpack_public_path__ + "static/media/website.397c46cb.svg";